import { render } from "./AdmChoosePlan.vue?vue&type=template&id=045e82fa&scoped=true&ts=true"
import script from "./AdmChoosePlan.vue?vue&type=script&lang=ts"
export * from "./AdmChoosePlan.vue?vue&type=script&lang=ts"

import "./AdmChoosePlan.vue?vue&type=style&index=0&id=045e82fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045e82fa"]])

export default __exports__